var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 853,
    height: 73,
    viewBox: "0 0 853 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        filter: url(#Fondo_men\xFA);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_13219",
    "data-name": "Rect\\xE1ngulo 13219",
    className: "cls-1",
    width: 853,
    height: 73,
    transform: "translate(-21483 -24018.031)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Fondo_men\\xFA",
    x: -19,
    y: -2.992,
    width: 891,
    height: 85.002,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu_adaptado",
    className: "cls-2",
    transform: "translate(21483 24018.031)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4",
    transform: "matrix(1, 0, 0, 1, -21483, -24018.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fondo_men\\xFA-2",
    "data-name": "Fondo_men\\xFA",
    className: "cls-3",
    d: "M882,62H9V-5H408.664a36.888,36.888,0,0,0,11.859,23.8A36.9,36.9,0,0,0,445.5,28.5a36.9,36.9,0,0,0,24.978-9.7A36.888,36.888,0,0,0,482.336-5H882V62Z",
    transform: "translate(-19 11.01)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBackground);
export default __webpack_public_path__ + "static/media/menu_background.0a0f0d8228be513b37f6e06c6ad77cfb.svg";
export { ForwardRef as ReactComponent };